var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        "open-on-hover": "",
        "open-delay": _vm.openDelay,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c("v-hover", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ hover }) {
                        return _c(
                          "v-icon",
                          _vm._g(
                            {
                              staticClass: "clickable",
                              attrs: {
                                size: _vm.small ? _vm.minSize : null,
                                color: hover ? _vm.activeColor : _vm.color,
                              },
                            },
                            on
                          ),
                          [_vm._v("\n        info_outline\n      ")]
                        )
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _vm._t("default", function () {
                return [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }